import { differenceWith, intersection, isEqual } from '@fareye/utils'
import React, { useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { ICustomTabsProps } from '../utility/types'

const CustomTabs = ({
  onChange,
  className,
  style,
  listClassName,
  listStyle,
  tabClassName,
  tabStyle,
  tabPanelClassName,
  tabPanelStyle,
  tabNameList = [],
  tabContentList = []
}: ICustomTabsProps) => {
  const [tabIndex, changeTabIndex] = useState(0)
  let classArray: string[] = className ? className.split(' ') : []
  let removeClassList: string[] = intersection(classArray, [
    'lg',
    'md',
    'sm',
    'xs',
    'xxs'
  ])
  let remainingClass = differenceWith(
    classArray,
    removeClassList,
    isEqual
  ).join(' ')
  return (
    <Tabs
      className={`feui-tabs-grouped-button${
        remainingClass ? ' ' + remainingClass : ''
      }`}
      style={style}
      selectedIndex={tabIndex}
      onSelect={tabIndex => {
        changeTabIndex(tabIndex)
      }}
    >
      <TabList
        className={`react-tabs__tab-list${
          listClassName ? ` listClassName` : ''
        }`}
        style={listStyle ? listStyle : {}}
      >
        {tabNameList.map((val: any, index: number) => (
          <Tab
            key={`tab${index}`}
            className={`tab-button${tabClassName ? ` ${tabClassName}` : ''}${
              removeClassList[0] ? ` ${removeClassList[0]}` : ''
            }`}
            style={tabStyle ? tabStyle : {}}
          >
            {val}
          </Tab>
        ))}
      </TabList>
      {tabContentList.map((val: any, index: number) => (
        <TabPanel
          key={`panel${index}`}
          className={`tab-panel ${
            removeClassList[0] ? ` ${removeClassList[0]}` : ''
          }`}
        >
          {val}
        </TabPanel>
      ))}
    </Tabs>
  )
}
export default CustomTabs
